import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';
import { getAllworkflow, updateWorkflow } from '../../../api/workflow';
import { failed, success } from '../../../utils/Tostify';
import { useConfirmDialog } from '../../../hooks/useConfirmDialog';
import { decryptData } from '../../../utils/helper';
import CustomPagination from '../../../components/Pagination/CustomPagination';
import moment from 'moment';
import Loader from '../../../components/Loader/Loader';
import EditWorkflow from './EditWorkflow';

function WorkflowList({searchValue, direction, ...args }) {
  let token = useSelector(state => state.userReducer.token);
  const [dropdownOpen, setDropdownOpen] = useState([]);
  const [workflowData, setWorkflowData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [workflowList, setWorkflowList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { getConfirmation } = useConfirmDialog();
  const dispatch  = useDispatch();
  const toggleDropdown = (id) => {
    setDropdownOpen(prevState => prevState.includes(id) ? prevState.filter(item => item !== id) : [...prevState, id]);
  };
  const getWorkflowList = async (page, limit, searchKey = "") => {
    let res;
    try {
        setIsLoading(true);
        // setSearch(searchKey);
        res = await getAllworkflow({dispatch, token, page, limit, searchKey});
        const responseData = decryptData(res?.data);
        if (res?.status === "SUCCESS") {
          setWorkflowList(responseData);
            setIsLoading(false);
        }else{
          setIsLoading(false);
          failed(res?.message);
        }
    } catch (error) {
        failed(res?.message);
        setIsLoading(false);
    }
  };

  const handlePagination = (page) => {
    getWorkflowList(page, 10);
  };

  const handlePublished = async (e, workflowId) => {
    const isChecked = e.target.checked;
    e.target.checked = !isChecked;
    const msg = isChecked ? "Publish" : "Unpublish";
    const confirmed = await getConfirmation({
        title: "Attention!",
        entryName: "",
        actionBtnTitle: "Yes",
        message: `Are you sure you want to ${msg}?`
    });
    if (confirmed) {
        let res;
        try {
            const values = {isPublished: isChecked};
            setIsLoading(true);
            res = await updateWorkflow({values, dispatch, token, workflowId});
            if (res?.status === "SUCCESS") {
                await getWorkflowList(workflowList?.currentPage, 10);
                setIsLoading(false);
                success(res?.message);
            } else {
                setIsLoading(false);
                failed(res?.message);
            }
        } catch (error) {
            setIsLoading(false);
            failed(res?.message);
        }
    } else {
        e.target.checked = !isChecked;
    }
  };

  const handleDelete = async(workflowName, workflowId)=>{
    const isActive = workflowList?.items?.find((obj)=> obj?._id == workflowId)?.isPublished;
        if(isActive){
            failed("You can't delete an Published Workflow");
            return;
        }
    const confirmed = await getConfirmation({
        title: "Attention!",
        entryName: "",
        actionBtnTitle: "Yes",
        message: `Are you sure you want to Delete ${workflowName}?`
    });
    if (confirmed) {
        let res;
        try {
            const values = {isDeleted: true};
            setIsLoading(true);
            res = await updateWorkflow({values, dispatch, token, workflowId});
            if (res?.status === "SUCCESS") {
                await getWorkflowList(workflowList?.currentPage, 10);
                setIsLoading(false);
                success(res?.message);
            } else {
                setIsLoading(false);
                failed(res?.message);
            }
        } catch (error) {
            setIsLoading(false);
            failed(res?.message);
        }
    }
  };

  useEffect(() => {
    getWorkflowList(1, 10);
  }, []);
  useEffect(() => {
    let timerOut = setTimeout(async () => {
      getWorkflowList(1, 10, searchValue);
    }, 1000);
    return () => clearTimeout(timerOut);
}, [searchValue]);

  return (
    <Fragment>
      {isLoading && <Loader/>}
      {showModal ? <EditWorkflow refetch={()=> getWorkflowList(workflowList?.currentPage, 10)} setShowModal={()=> setShowModal(!showModal)} workflowData={workflowData}/> : null}
      <div className="table_space table_listing_color">
        <div className="forms_block_workflow">
          <div className="table-responsive">
            <table>
              <thead>
                <tr className="header_table">
                  <th>Workflow Name</th>
                  <th>State</th>
                  <th>Application Type</th>
                  <th>Updated</th>
                  <th>Publish</th>
                  <th>Actions</th>
                </tr>
              </thead>
              {workflowList.items?.length > 0 ? workflowList.items.map((work, index)=> (
              <tbody key={work?._id}>
                <tr>
                  <td colSpan={8} className="bg_light"></td>
                </tr>
                <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                  <td>{work?.workflowTitle}</td>
                  <td>{work?.state?.label}</td>
                  <td>{work?.applicationType?.applicationTitle}</td>
                  <td>{moment(work?.updatedAt).format("MMM-DD-YYYY")}</td>
                  <td>
                    <div className="toggle">
                        <input
                            type="checkbox"
                            id={`checktoggle-${work._id}`}
                            onChange={(e) => handlePublished(e, work?._id)}
                            checked={work?.isPublished}
                        />
                        <label htmlFor={`checktoggle-${work._id}`}></label>
                    </div>
                  </td>
                  <td>
                  <Dropdown  className="dropdown_blk" isOpen={dropdownOpen.includes(work?._id)} toggle={() => toggleDropdown(work?._id)}  direction={direction}>
                        <DropdownToggle caret size="xl" className="column_blk">
                            <div className="for_details">
                              <i className="fa fa-ellipsis-v"></i>
                            </div>
                        </DropdownToggle>
                        <DropdownMenu {...args}>
                          <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={()=> {setShowModal(true); setWorkflowData({...work, readOnly:false});}}>
                            <div className="add_hosp">Edit</div>
                          </DropdownItem>
                          <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={()=> {setShowModal(true); setWorkflowData({...work, readOnly:true});}}>
                              <div className="add_hosp">View Details</div>
                          </DropdownItem>
                          <DropdownItem className="d-flex gap-2 drop_block_content align-items-center" onClick={()=> handleDelete(work?.workflowTitle, work?._id)}>
                                <div className="add_hosp" >Delete</div>
                          </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                  </td>
                </tr>
                <tr>
                  <td colSpan={8} className="bg_light"></td>
                </tr>
              </tbody>)) : <tr><td colSpan={10}><p className="text-center">No Data Found</p></td></tr> }           </table>
          </div>
          <CustomPagination
            tableData={workflowList?.items}
            totalPages={workflowList?.totalPages}
            totalRows={workflowList?.totalItems}Fragment
            rowsPerPage={10}
            page={workflowList?.currentPage}
            handlePage={handlePagination}
        />
        </div>
      </div>
    </Fragment>
  );
}

export default WorkflowList;
